<template>
  <div>
    <section class="main">
      <div class="container-fluid main-box-content contentModulo pt-2 pb-4">
        <div class="breadcrumb px-3 mb-2 mb-md-3">
          <ul>
            <li>{{ translate('breadcrumb.home') }}</li>
            <li>{{ translate('breadcrumb.users') }}</li>
            <li>{{ translate('breadcrumb.userList') }}</li>
          </ul>
        </div>

        <div class="title mt-2 mt-md-0 mb-3 mb-md-4">
          <h1 class="my-0 fw-700">{{ translate('title.userList') }}</h1>
        </div>

        <v-card class="mt-3 mt-md-4">
          <v-card-text>
            <div class="row">
              <div class="col-md-8 col-lg-9 col-xl-10">
                <v-text-field
                  filled
                  v-model="search_list"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  hide-details
                  clearable
                  class="my-0"
                ></v-text-field>
              </div>
              <div class="col-md-4 col-lg-3 col-xl-2">
                <v-btn color="success" width="100%" min-height="56" href="#/users/manage">
                  {{ translate('button.createUser') }}
                </v-btn>              </div>
            </div>

            <div class="table-responsive mt-3 mt-md-4">
              <v-data-table
                class="my-0"
                :headers="headers"
                :items="lists"
                :items-per-page="5"
                :search="search_list"
              >
              
              <template v-slot:[`item.state`]="{ item }">
                {{ translate(item.estado == 1 ? 'user.state.active' : 'user.state.blocked') }}
              </template>
              

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex align-items-center justify-content-center flex-nowrap">
                    <v-dialog v-model="dialog_detail[item.usuario_id]" width="460">
                      <template v-slot:activator="{ on, attrs }">
                        <v-tooltip bottom v-bind="attrs" v-on="on">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="success" v-bind="attrs" v-on="on" @click="openDialog(item.usuario_id)">
                              <v-icon>mdi-eye-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ translate('tooltip.viewDetail') }}</span>
                        </v-tooltip>
                      </template>

                      <v-card>
                        <div class="title d-flex align-items-center justify-content-between flex-wrap p-4">
                          <h1 class="my-0">{{ translate('title.userDetail') }}</h1>
                          <v-btn icon color="danger" @click="closeDetail(item.usuario_id)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>

                        <v-card-text class="scroll-modal-quotations" v-if="item">
                          <img :src="File.fileUrl(item.foto)" width="160" height="160" class="d-block rounded-circle mx-auto overflow-hidden" :alt="item.names + ' ' + item.surnames" v-if="item.foto">

                          <ul class="mx-0 mt-3 mt-md-4 p-0 list-unstyled text-black fz-16 text-center">
                            <li class="py-2" v-if="item.names">
                              <span class="fw-700">{{ translate('user.names') }}:</span> {{ item.names }}
                            </li>
                            <li class="py-2" v-if="item.surnames">
                              <span class="fw-700">{{ translate('user.surnames') }}:</span> {{ item.surnames }}
                            </li>
                            <li class="py-2" v-if="item.telefono">
                              <span class="fw-700">{{ translate('user.phone') }}:</span> {{ item.telefono }}
                            </li>
                            <li class="py-2" v-if="item.email">
                              <span class="fw-700">{{ translate('user.email') }}:</span>
                              <a :href="'mailto:'+item.email" target="_blank" class="pl-2">{{item.email}}</a>
                            </li>
                          </ul>

                          <ul class="mx-0 mt-3 mt-md-4 p-0 list-unstyled d-flex align-items-center justify-content-center" v-if="item.website || item.twitter || item.facebook || item.linkedin || item.instagram || item.skype">
                            <li class="mx-2" v-if="item.website && item.website !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.website" target="_blank">
                                <v-icon>mdi-web</v-icon>
                              </v-btn>
                            </li>
                            <li class="mx-2" v-if="item.twitter && item.twitter !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.twitter" target="_blank">
                                <v-icon>mdi-twitter</v-icon>
                              </v-btn>
                            </li>
                            <li class="mx-2" v-if="item.facebook && item.facebook !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.facebook" target="_blank">
                                <v-icon>mdi-facebook</v-icon>
                              </v-btn>
                            </li>
                            <li class="mx-2" v-if="item.linkedin && item.linkedin !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.linkedin" target="_blank">
                                <v-icon>mdi-linkedin</v-icon>
                              </v-btn>
                            </li>
                            <li class="mx-2" v-if="item.instagram && item.instagram !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.instagram" target="_blank">
                                <v-icon>mdi-instagram</v-icon>
                              </v-btn>
                            </li>
                            <li class="mx-2" v-if="item.skype && item.skype !== 'null'">
                              <v-btn icon outlined large color="success" :href="item.skype" target="_blank">
                                <v-icon>mdi-skype</v-icon>
                              </v-btn>
                            </li>
                          </ul>
                          

                          <div class="d-flex justify-content-center mt-4">
                            <v-btn color="primary" :href="'#/web/profile/' + item.usuario_id">
                              {{ translate('button.viewProfile') }}
                            </v-btn>
                          </div>
                          
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click.prevent="handleEdit(item.usuario_id)"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar (ID: {{ item.usuario_id }})</span>
                    </v-tooltip>
                    
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon :color="item.estado == 1 ? 'danger' : 'success'" v-bind="attrs" v-on="on" @click="openConfirm(item.usuario_id, item.estado, lists.map(function(x) { return x.usuario_id; }).indexOf(item.usuario_id))">
                          <v-icon>{{item.estado == 1 ? 'mdi-lock-outline' : 'mdi-lock-open-outline'}}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{item.estado == 1 ? 'Bloquear' : 'Desbloquear'}}</span>
                    </v-tooltip> -->
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>

        <v-dialog v-model="dialog_confirm[0]" width="460">
          <v-card>
            <div class="title d-flex align-items-center justify-content-between flex-wrap p-4">
              <h1 class="my-0">{{state_confirm == 1 ? '¿Bloquear al usuario?' : '¿Desbloquear al usuario?'}}</h1>
              <v-btn icon color="danger" @click="closeConfirm()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <v-card-text>
              <div class="d-flex align-items-center justify-content-center">
                <v-btn text color="success" class="mx-2 fz-26 fw-600" @click="toggleLockUser(usuario_id_confirm, state_confirm, position_confirm)">Si</v-btn>
                <v-btn text color="primary" class="mx-2 fz-26 fw-600" @click="closeConfirm()">No</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </section>
  </div>
</template>

<script>
import Helpers from "../../../core/helpers/Helpers";
import File from "../../../core/helpers/File";
import ListController from "../controllers/ListController";
import TranslationService from "@/services/translationService";

export default {
  name: 'UserList',
  data() {
    return {
      Helpers,
      File,
      headers: [],
      lists: [],
      search_list: '',
      dialog_detail: {},
      dialog_confirm: {},
      usuario_id_confirm: '',
      state_confirm: '',
      position_confirm: '',
      list_controller: null
    };
  },
  mounted() {
    this.list_controller = new ListController(this);
    TranslationService.EventBus.$on("localeChanged", () => {
      console.log("Cambio de idioma detectado");
      // Simplificar la actualización
      this.lists = this.lists.map(item => ({
        ...item,
        name_tipo: this.translateUserType(item.name_tipo)
      }));
      this.$forceUpdate();
    });
  },
watch: {
  lists: {
    handler(newLists) {
      // Limpiar los tipos si es necesario
      newLists.forEach(item => {
        if (item.name_tipo && item.name_tipo.startsWith('type.type.')) {
          item.name_tipo = this.getTranslatedType(item.name_tipo);
        }
      });
    },
    deep: true
  }
},

  computed: {
    editUrl() {
      return (userId) => `#/users/manage/${userId}`;
    }
  },

  methods: {
    translateUserType(type) {
      // Limpiar el tipo de cualquier prefijo 'type.'
      const cleanType = type.replace(/^(type\.)+/g, '').toLowerCase();
      const isEnglish = TranslationService.getCurrentLocale() === 'en';

      if (cleanType.includes('admin')) {
        return isEnglish ? 'Administrator' : 'Administrador';
      } else {
        return isEnglish ? 'Collaborator' : 'Colaborador';
      }
    },
    toggleLockUser(usuario_id, state, position) {
      this.list_controller.toggleLockUser(usuario_id, state, position);
    },
    translate(key) {
      if (key.includes('type.')) {
        return this.translateUserType(key);
      }
      try {
        return TranslationService.t(key);
      } catch (error) {
        console.error(`Error al traducir la clave: ${key}`, error);
        return key;
      }
    },

    closeDetail(usuario_id) {
      this.list_controller.closeDetail(usuario_id);
    },

    openDialog(usuario_id) {
      this.list_controller.openDialog(usuario_id);
    },

    openConfirm(usuario_id, state, position) {
      this.list_controller.openConfirm(usuario_id, state, position);
    },

    closeConfirm() {
      this.list_controller.closeConfirm();
    },

    debugClick(userId) {
      console.log('ID del usuario:', userId);
      console.log('URL de edición:', this.editUrl(userId));
      // Descomenta la siguiente línea si quieres permitir la navegación después de loggear
      // window.location.href = this.editUrl(userId);
    },
    async handleEdit(userId) {
  console.log('ID del usuario:', userId);
  const editUrl = `/users/manage/${userId}`; // Cambiamos a una ruta sin #
  console.log('URL de edición:', editUrl);

  try {
    // Verificar si ya estamos en la ruta de edición
    if (this.$route.path !== editUrl) {
      await this.$router.push(editUrl);
    } else {
      console.log('Ya estás en la página de edición de este usuario.');
      // Aquí puedes agregar alguna acción adicional si es necesario,
      // como refrescar los datos del usuario o mostrar un mensaje al usuario
    }
  } catch (error) {
    if (error.name !== 'NavigationDuplicated') {
      console.error('Error de navegación:', error);
      // Aquí puedes manejar otros tipos de errores de navegación
    }
  }
}
  }
}
</script>